import { TabsProps } from '@material-ui/core';

export const tabs: TabsProps = {
  indicatorColor: 'primary',
  value: undefined,
};
